import React from 'react';
import PropTypes from 'prop-types';
import ButtonProgress from '../../commons/ButtonProgress';

function VerifyButton ({ label, onClick, showProgress, disabled, width }) {
  return (
    <ButtonProgress
      label={label}
      variant="contained"
      onClick={onClick}
      showProgress={showProgress}
      disabled={disabled}
      width={width}
    />
  );
}

VerifyButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  showProgress: PropTypes.bool,
  disabled: PropTypes.bool,
  width: PropTypes.string,
};

VerifyButton.defaultProps = {
  label: 'Verify OTP',
  onClick: () => {},
  showProgress: false,
  disabled: false,
  width: '120px',
};

export default VerifyButton;
